import React, { useEffect, useState } from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import { useGetAdditionalById, useUpdateAdditional } from "~/entity/Contract";
import {
  additionalFormId,
  FormAdditional,
} from "~/pages/ListOfDocuments/Modals/Components/FormAdditional";
import {
  editAdditionalToForm,
  editAdditionalToServer,
} from "~/pages/ListOfDocuments/Modals/helper";
import { TITLES } from "~/pages/ListOfDocuments/Modals/options";
import { useTrustedPersons } from "~/pages/ListOfDocuments/hooks/useTrustedPersons";
import { useNotify } from "~/shared/hooks/useNotify";

interface EditAdditionalIProps {
  open: boolean;
  onClose: () => void;
  dealerObj: any;
  print: boolean;
}

const EditAdditional = ({
  open,
  onClose,
  dealerObj,
  print,
}: EditAdditionalIProps) => {
  const [formState, setFormState] = useState(null);
  const [confidant, setConfidant] = useState(null);
  const [loading, setLoading] = useState(false);
  const { mutate } = useUpdateAdditional();

  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();

  const { data, isLoading } = useGetAdditionalById({
    id: dealerObj.contractId,
    parentContractId: dealerObj.parentContractId,
    printFormId: dealerObj.printFormId,
  });

  const { dataOptions, trustedPersonsState } = useTrustedPersons();

  useEffect(() => {
    if (trustedPersonsState?.data) {
      const dataConfidant = dataOptions.find(
        (item) => Number(item.value) === Number(dealerObj.confidantId),
      );
      setConfidant(dataConfidant);
    }
  }, [trustedPersonsState?.data]);

  useEffect(() => {
    if (data && confidant && dealerObj) {
      setFormState(editAdditionalToForm(data, confidant, dealerObj));
      setLoading(true);
    }
  }, [data, confidant, dealerObj]);

  const submit = (data) => {
    mutate(
      {
        data: editAdditionalToServer(data, Number(dealerObj.id)),
        id: dealerObj.contractId,
      },
      {
        onSuccess: () => {
          notifySuccess(t("contract.update_additional_success"));
          onClose();
        },
        onError: () => {
          notifyError(t("contract.update_additional_error"));
        },
      },
    );
  };

  const formReady = !isLoading && loading;

  return (
    <Modal
      open={open}
      title={TITLES.additional.edit}
      onCancel={onClose}
      centered
      destroyOnHidden
      size="large"
      cancelButton={{ children: "Закрыть" }}
      okButton={
        formReady
          ? {
              htmlType: "submit",
              form: additionalFormId,
              children: "Сохранить",
            }
          : undefined
      }
    >
      {formReady ? (
        <FormAdditional
          submit={submit}
          contractId={dealerObj.contractId}
          dealerId={dealerObj.id}
          defaultValues={formState}
          printContract={print}
        />
      ) : (
        <Preloader />
      )}
    </Modal>
  );
};

export default EditAdditional;
